import { render, staticRenderFns } from "./VrTestResultHistory.vue?vue&type=template&id=1533e171&"
import script from "./VrTestResultHistory.vue?vue&type=script&lang=js&"
export * from "./VrTestResultHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports